import { defineAsyncComponent, defineComponent, h } from 'vue'
import { useBreakpoints } from '@/utils/useBreakpoints'
import type { Component } from 'vue'
import Spinner from '@/components/ui/spinner/Spinner.vue'

// Create a loading component with props
const LoadingComponent = defineComponent({
  name: 'LoadingComponent',
  setup() {
    return () => h(Spinner, { overlay: true })
  },
})

export function responsiveComponent(
  desktopComponent: () => Promise<Component>,
  mobileComponent: () => Promise<Component>,
  breakpoint: 'sm' | 'md' | 'lg' = 'md',
) {
  // define an async component based on given component for lazy loading and showing loading state
  const DesktopAsync = defineAsyncComponent({
    loader: desktopComponent,
    loadingComponent: LoadingComponent,
    delay: 0,
  })
  const MobileAsync = defineAsyncComponent({
    loader: mobileComponent,
    loadingComponent: LoadingComponent,
    delay: 0,
  })
  // define a wrapper component that chooses between desktop and mobile
  return defineComponent({
    name: 'ResponsiveWrapper',
    setup() {
      const breakpoints = useBreakpoints()
      const isMobile = breakpoints.smaller(breakpoint)

      return () => {
        const component = isMobile.value ? MobileAsync : DesktopAsync
        return h(component)
      }
    },
  })
}
